import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '250px'
    },
    height: {
      type: String,
      default: '320px'
    },
    top: {
      type: String,
      default: '16px'
    },
    left: {
      type: String,
      default: '245px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    //   this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(getvalue, getdata, sum) {
      //	得到仪表盘
      sum == undefined ? sum = 5000 : ''; // var colorList = ['#8818F0', '#00D0BF', '#1875F0', '#797AFF', '#797AFF']

      var colorList = ['#00D0BF', "#00D0BF", "#00D0BF", "#00D0BF", "#00D0BF", "#00D0BF", '#00D0BF'];
      var values = [];
      var max = 0;
      getvalue.forEach(function (item, index) {
        if (item > max) {
          max = item;
        }

        values.push(item);
      });

      if (max > sum) {
        sum = max * 1.1;
      }

      var getsum = [sum, sum, sum, sum, sum, sum];
      console.log('getsum', getsum);
      console.log('max', max);
      console.log('getvalue', getvalue);
      console.log('getdata', getdata);
      console.log('sum', sum);
      var option = {
        // backgroundColor:'#fff',
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: '10%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function formatter(params) {
            return params[0].marker + params[0].axisValue + ':' + params[0].value + '天';
          }
        },
        xAxis: {
          show: false,
          type: 'value'
        },
        yAxis: [{
          type: 'category',
          inverse: true,
          axisLabel: {
            show: false,
            textStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: getdata
        }, {
          type: 'category',
          inverse: true,
          axisTick: 'none',
          axisLine: 'none',
          show: true,
          axisLabel: {
            shadowOffsetX: '-20px',
            color: ['#fff'],
            align: 'right+20',
            verticalAlign: 'center',
            lineHeight: 20,
            textStyle: {
              color: '#0ff',
              fontSize: '14'
            },
            formatter: function formatter(value) {
              return value + ' 天';
            }
          },
          data: values
        }],
        series: [{
          name: '新生报到比例',
          type: 'bar',
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 8,
              color: function color(params) {
                return colorList[params.dataIndex];
              }
            }
          },
          barWidth: 10,
          data: values
        }, {
          name: '背景',
          type: 'bar',
          barWidth: 10,
          barGap: '-100%',
          data: getsum,
          itemStyle: {
            normal: {
              color: '#acc8ea',
              barBorderRadius: 8
            }
          },
          label: {
            normal: {
              color: '#fff',
              show: true,
              position: [0, '-20px'],
              textStyle: {
                fontSize: 14
              },
              formatter: function formatter(a, b) {
                return a.name;
              }
            }
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};